const breadcrumbId = document.getElementById("breadcrumbMM");
const collections = JSON.parse(breadcrumbId.dataset.collection);
const productType = breadcrumbId.dataset.productType;
const linkBreadcrumb = document.createElement("span");
const data = JSON.parse(sessionStorage.getItem("menu_history"));

data ? checkIfCollectionExists() : notCollectionExists();

function checkIfCollectionExists() {
  
  if (Object.keys(data.menuHistory).length !== 0) {
    for (const [key, value] of Object.entries(data.menuHistory)) {
      const { url } = value;
      const newUrl = url.split("/").slice("-1").toString();
      collections.includes(newUrl)
        ? createHistoryLinks(value)
        : updateBreadcrumb(key.replace("collection", ""));
    }
  } else notCollectionExists();
}

function notCollectionExists() {
  const breadcrumbProductType = createHistoryLinks({
    title: productType,
    url: `/pages/search-results-page?rb_product_type=${productType}`,
  });
  breadcrumbId.appendChild(breadcrumbProductType);
}

function createHistoryLinks(collection) {
  const { title, url } = collection;
  const linkCollection = document.createElement("a");
  linkCollection.setAttribute("itemprop", "item");
  linkCollection.href = url || "#";
  linkCollection.innerHTML = `${title} ` || "";

  return breadcrumbId.appendChild(linkCollection);
}

function updateBreadcrumb(position) {
  const data = JSON.parse(sessionStorage.getItem("menu_history"));
  delete data.menuHistory[`collection${position}`];
  sessionStorage.setItem("menu_history", JSON.stringify(data));

  Object.keys(data.menuHistory).length === 0 && notCollectionExists();
}
